module.exports = __webpack_public_path__ + "static/ai-ocr-a3059ac62cfbc82a0cec320fc312b963.png";